/* eslint-disable import/no-cycle */
import { HStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdOutlineCheckBoxOutlineBlank } from 'react-icons/md';
import FormTextInput from '../formInputs/FormTextInput';
import { FormBuilderComponentProps } from '../types';

function CheckBoxFieldComponent({ fieldId, isAdvanced }: Pick<FormBuilderComponentProps, 'fieldId' | 'isAdvanced'>) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <HStack align="flex-start">
      <MdOutlineCheckBoxOutlineBlank fontSize={20} />
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.text')} isAdvanced={isAdvanced || false} />
    </HStack>
  );
}

export const CheckBoxField = React.memo(CheckBoxFieldComponent, (prev, next) => prev.fieldId === next.fieldId);
